export const COPYRIGHT_ENGLISH = "© 2026 South Westphalia University of Applied Sciences";
//# sourceMappingURL=constants.js.map